// eslint-disable-next-line
export function hasKey<O extends object>(obj: O, key: keyof any): key is keyof O {
    return key in obj
}
